<template>
    <div class="submission-status">
        <h1 class="submission-status__title">A/S접수 방법 안내</h1>
        <div class="submission-status__message">
            <div class="submission-status__message-icon" v-html="message.icon"></div>
            <h2 class="submission-status__message-title" v-html="message.title">}</h2>
            <p v-if="message.content" v-html="message.content"></p>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        message: {
            title: String,
            content: String,
            icon: String,
        }
    },
    data() {
        return {
        };
    },
    methods: {

    }
};
</script>
<style lang="scss" scoped>
$color-primary: #ef8009;

.submission-status{
    &__title { margin: 16px 0; line-height: 1; font-size: 24px; }
    &__message{
        padding: 60px 24px 44px; line-height: 1.6; text-align: center; font-size: 18px; color: #555555;
        border-top: 4px solid transparentize($color-primary, .9);
        border-bottom: 1px solid #e6e6e6;
        p{
            margin: 16px 0;
        }
    }
    &__message-icon{
        margin: 0 auto 24px; height: 80px;
        ::v-deep svg { width: auto; height: 100%; }
    }
    &__message-title{
        line-height: 1; font-size: 36px; color: $color-primary;
    }
}

@media(max-width:1200px){
.submission-status{
    &__title { font-size: 18px; }
    &__message{
        font-size: 14px;
    }
    &__message-icon{
        height: 58px;
    }
    &__message-title{
        font-size: 20px;
    }
}
}
@media(max-width:768px){
    
}
</style>
